import { useEffect, useState } from 'react';

import { handleError } from '@/services/handleError';
import { useAppSelector } from '@/store';
import type { TDocumentsOnModeration } from '@/types/uploadFiles';

const useModerationDocuments = () => {
  const { selectedBank } = useAppSelector((state) => state.financingStep);

  const [documentsOnModeration, setDocumentsOnModeration] = useState<
    TDocumentsOnModeration[]
  >([]);

  useEffect(() => {
    try {
      const parsedLogBody = JSON.parse(selectedBank?.bankDescription || '{}');
      if (
        parsedLogBody?.unrecognizedDocuments &&
        selectedBank?.status.code === 'on_rework'
      ) {
        setDocumentsOnModeration(parsedLogBody.unrecognizedDocuments);
      }
    } catch (error) {
      handleError(error);
    }
  }, [selectedBank]);

  return { documentsOnModeration };
};

export default useModerationDocuments;
